var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import { themeGet } from 'styled-system';
import { Text } from 'pcln-design-system';
var IconWrapper = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
function BaseComponent(_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    var themeContext = React.useContext(ThemeContext);
    var themeProps = {
        theme: themeContext,
    };
    return (React.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', focusable: false, "aria-hidden": true, role: 'img', "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            React.createElement("path", { d: 'M22.18.75c.2.007.396.041.585.104l.185.072.127.127c.108.243.168.505.175.76l-.01.424c-.073 1.309-.77 2.505-2.065 3.914l-.344.364-.66.668-2.191 2.146.48 1.588a1.588 1.588 0 011.643.082l.127.092 1.397 1.397a1.5 1.5 0 01.386 1.123c-.027.36-.184.696-.411.925l-.102.092-1.47 1.468 1.296 4.276c.1.332.032.69-.177.961l-.085.098-.547.547a.87.87 0 01-1.4-.204l-4.8-8.822-1.094 1.092-1.035 1.023a20.36 20.36 0 01-2.987 2.583l.346 4.464a.34.34 0 01-.09.24l-.54.54a.37.37 0 01-.59-.09l-1.814-3.607-.026.012a1.4 1.4 0 01-1.372-.084l-.129-.09a1.408 1.408 0 01-.273-1.325l.085-.226-3.601-1.81a.37.37 0 01-.178-.204l-.017-.068a.37.37 0 01.06-.264l.045-.054.54-.54a.34.34 0 01.174-.085l.066-.005 4.465.354a20.329 20.329 0 012.191-2.586l.406-.393 2.12-2.134-8.835-4.808a.87.87 0 01-.291-1.314l.08-.089.549-.548a1.07 1.07 0 011.057-.261L7.906 3.97 9.34 2.54a1.5 1.5 0 012.068-.252l.124.103 1.422 1.426c.395.51.43 1.189.134 1.723l1.598.485 2.135-2.196.478-.478c.162-.159.319-.31.472-.453l.447-.405C19.525 1.345 20.552.812 21.776.759l.405-.008z', fill: themeGet('palette.primary.base')(themeProps) }),
            React.createElement("path", { d: 'M18.86 11.85a.57.57 0 01.628-.065l.084.054 1.333 1.339.042.056a.511.511 0 01-.054.595l-.059.057-1.13 1.125-.93-3.07.015-.022.071-.07zm-8.392-8.865a.5.5 0 01.31.08l.064.049 1.363 1.364.042.07a.58.58 0 01-.093.595l-.07.071-.02.016-3.073-.93 1.091-1.092.074-.078a.504.504 0 01.312-.145z', fill: themeGet('palette.primary.light')(themeProps) }),
            React.createElement("path", { d: 'M21.692 2.329l.032.041.09.1a1.195 1.195 0 01-.092 1.6.275.275 0 11-.386-.392.645.645 0 000-.918l-.034-.044-.078-.065a.655.655 0 00-.842.068.275.275 0 11-.387-.39 1.205 1.205 0 011.697 0z', fill: themeGet('palette.background.lightest')(themeProps) }))));
}
var FlightsFill = function (props) { return (React.createElement(IconWrapper, { fontSize: props.size, lineHeight: props.size, verticalAlign: 'middle', className: props.className },
    React.createElement(BaseComponent, null))); };
FlightsFill.propTypes = {
    title: PropTypes.string,
    size: PropTypes.string,
};
/** @public */ var Memo = memo(FlightsFill);
export default Memo;
var templateObject_1;
//# sourceMappingURL=FlightsFill.js.map